import React from 'react';

export default function Loader() {
    return (
        <div className="loaderLayout">
            Loading...
        </div>
    );
}
